import React, {useEffect, useState} from 'react';
import {
    Button,
    Container,
    Dropdown,
    Form,
    Grid, Icon,
    Image,
    Input,
    Label,
    Menu,
    Message,
    Modal,
    Segment
} from "semantic-ui-react";
import {checkCoupon, getCourses, getFreight, postPeopleCourses} from "../../redux/actions";
import {useHistory} from "react-router";
import moment from "moment";
import axios from "axios";

const freightTypes = [
    {
        key: '41106',
        value: '41106',
        text: 'PAC',
    }, {
        key: '40010',
        value: '40010',
        text: 'SEDEX',
    }
];

const quantities = [
    {
        key: '1',
        value: '1',
        text: '1 Unidade',
    }, {
        key: '2',
        value: '2',
        text: '2 Unidades',
    }, {
        key: '3',
        value: '3',
        text: '3 unidades',
    }, {
        key: '4',
        value: '4',
        text: '4 Unidades',
    }, {
        key: '5',
        value: '5',
        text: '5 Unidades',
    }, {
        key: '6',
        value: '6',
        text: '6 Unidades',
    }, {
        key: '7',
        value: '7',
        text: '7 Unidades',
    }, {
        key: '8',
        value: '8',
        text: '8 Unidades',
    }, {
        key: '9',
        value: '9',
        text: '9 Unidades',
    }, {
        key: '10',
        value: '10',
        text: '10 Unidades',
    }
];

const getMainFreight = async ({postalType, postalCode, course, quantity}) => {

    try{
        let res = await getFreight({
            "nCdServico": postalType,
            "sCepOrigem": course.postal_code,
            "sCepDestino": postalCode,
            "nVlPeso": course.weight / 1000,
            "nVlComprimento": course.length,
            "nVlAltura": course.height,
            "nVlLargura": course.width,
            "productId": course.id,
            "quantity": quantity
        });

        return res;
    }catch (e) {
        return e;
    }
}

const ModalFreight = ({open, setOpen, course, quantity, setFreight}) => {
    const [postalType, setPostaType] = useState('41106');
    const [postalCode, setPostaCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [details, setDetails] = useState({});

    const [street, setStreet] = useState('');
    const [streetNumber, setStreetNumber] = useState('');
    const [complement, setComplement] = useState('');
    const [sublocality, setSublocality] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');

    const getCalcFreight = async () => {

        try {
            // let res = await getFreight({
            //     "nCdServico": postalType,
            //     "sCepOrigem": course.postal_code,
            //     "sCepDestino": postalCode,
            //     "nVlPeso": course.weight / 1000,
            //     "nVlComprimento": course.length,
            //     "nVlAltura": course.height,
            //     "nVlLargura": course.width,
            //     "productId": course.id,
            //     "quantity": quantity
            // });

            let res = await getMainFreight({postalType, postalCode, course, quantity});

            res.data.Valor = res.data.Valor.replace(',', '.');

            setDetails(res.data);
        } catch (e) {
            console.log("erro ao calcular frete");
        }
    }

    const getData = async() => {

        setLoading(true);
        setDetails({});

        if(postalCode.length != 8){
            setLoading(false);
            return;
        }

        try{
            await getCalcFreight();

            const viaCep = await axios.get('https://viacep.com.br/ws/'+postalCode+'/json/');
            const address = viaCep.data;

            setStreet(address.logradouro);
            setSublocality(address.bairro);
            setCity(address.localidade);
            setState(address.uf);

        }catch (e) {
            console.log(e);
        }finally {
            setLoading(false);
        }
    }

    const selectFreight = () => {
        let formatted_address = street + ', ' + streetNumber;
        if (complement) {
            formatted_address += ' - ' + complement
        }
        formatted_address += ', ' + sublocality + ' - ' + city + ' / ' + state;

        const address = {
            street,
            street_number: streetNumber,
            complement,
            sublocality,
            city,
            state,
            postal_code: postalCode,
            formatted_address
        };

        const data = {...details, address};

        setFreight(data);

        setOpen(false);
    }

    useEffect(() => {

        getData();

    }, [postalType]);

    return (
        <Modal
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            size={"tiny"}
        >
            <Modal.Header>Endereço de Entrega</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <Form onSubmit={getData}>
                        <Form.Group widths={'equal'}>
                            <Form.Field width={2}>
                                <label>Modalidade</label>
                                <Dropdown
                                    selection
                                    options={freightTypes}
                                    value={postalType.toString()}
                                    onChange={(e, {value}) => setPostaType(value.toString())}
                                />
                            </Form.Field>
                            <Form.Field width={3}>
                                <label>Informe um CEP</label>
                                <Form.Input
                                    autoFocus={true}
                                    value={postalCode}
                                    action={{
                                        type: 'submit',
                                        content: 'Usar',
                                        loading,
                                        disabled: postalCode.length !== 8,
                                        onClick: getData
                                    }}
                                    maxLength={8}
                                    onChange={(e, {value}) => setPostaCode(value.replace(/\D/g, ''))}
                                />
                            </Form.Field>
                        </Form.Group>
                    {
                        details.Valor && (
                            <React.Fragment>
                                <Message>
                                    <strong>Prazo de entrega: </strong> {details.PrazoEntrega} dias<br />
                                    <strong>Valor: </strong> R$ {quantity * details.Valor}
                                </Message>
                                <Form.Group widths={'equal'}>
                                    <Form.Field>
                                        <Form.Input
                                            label={'Logradouro'}
                                            value={street}
                                            onChange={(e, {value}) => setStreet(value)}
                                        />
                                    </Form.Field>
                                    <Form.Field width={6}>
                                        <Form.Input
                                            autoFocus
                                            label={'Número'}
                                            value={streetNumber}
                                            onChange={(e, {value}) => setStreetNumber(value.replace(/\D/g, ''))}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group widths={'equal'}>
                                    <Form.Field  width={8}>
                                        <Form.Input
                                            label={'Complemento'}
                                            value={complement}
                                            onChange={(e, {value}) => setComplement(value)}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Form.Input
                                            label={'Bairro'}
                                            value={sublocality}
                                            onChange={(e, {value}) => setSublocality(value)}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group widths={'equal'}>
                                    <Form.Field>
                                        <Form.Input
                                            label={'Cidade'}
                                            value={city}
                                            onChange={(e, {value}) => setCity(value)}
                                        />
                                    </Form.Field>
                                    <Form.Field >
                                        <Form.Input
                                            label={'Estado'}
                                            value={state}
                                            onChange={(e, {value}) => setState(value)}
                                        />
                                    </Form.Field>
                                </Form.Group>
                            </React.Fragment>
                        )
                    }
                    </Form>
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={() => setOpen(false)}>
                    Fechar
                </Button>
                {
                    details.Valor && <Button primary onClick={selectFreight}>
                        Selecionar
                    </Button>
                }
            </Modal.Actions>
        </Modal>
    )
}

const PriceDetails = ({course, buying, buy, quantity, setQuantity, freight, setFreight, token, login, setCouponId}) => {
    // const [freight, setFreight] = useState({});
    const [couponError, setCouponError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [discount, setDiscount] = useState({});
    const [coupon, setCoupon] = useState('');
    const [open, setOpen] = useState(false);

    if(!course.id){
        return <React.Fragment/>;
    }

    const handleCheckCoupon = async () => {
        try {
            setLoading(true);

            const res = await checkCoupon({
                place_id: course.place_id,
                name:coupon
            });

            setDiscount(res);
            setCouponError(!res.success);
            setCouponId(res.success ? res.data.id : undefined);
        }catch (e) {
            console.log(e);
        }finally {
            setLoading(false);
        }
    }

    const freightValue = parseFloat(freight.Valor || 0);
    const amount = quantity * course.price;
    const discountValue = discount.success ? ((discount.data.amount * amount) / 100) : 0;
    const subtotal = amount + freightValue;
    const total = subtotal - discountValue;

    return <div id={"buy-now"} className={'priceDetails'}>
        <Label size={"tiny"}>{course.course_category.name}</Label>
        <h3>{course.name}</h3>
        {
            course.origin ? <h4>R$ {course.origin.toFixed(2)}</h4> : ''
        }
        <h1>R$ {course.price.toFixed(2)}</h1>
        <div>
            em até <span>{course.installments}x R$ {(course.price / course.installments).toFixed(2)} sem juros</span>
        </div>
        {
        course.product && <React.Fragment><p>
            <strong>Estoque disponível</strong>
        </p>
            <Form.Field inline>
                Quantidade: {' '}
                <Dropdown
                    inline
                    options={quantities}
                    value={quantity.toString()}
                    onChange={(e, {value}) => setQuantity(value.toString())}
                />
            </Form.Field>

            <p>
                <strong>Endereço de entrega</strong>
                <a style={{cursor: "pointer", marginLeft: 16}} onClick={() => setOpen(true)}>( alterar )</a>
            </p>

            <Form.Field>
                {
                    freight.address ? freight.address.formatted_address : 'Defina um endereço de entrega'
                }
            </Form.Field>
        </React.Fragment>
        }

        <p>
            <strong>Cupom de desconto</strong>
            <Input
                id={"inputCoupon"}
                error={couponError}
                fluid
                loading={loading}
                icon={<Icon
                    name='search'
                    inverted
                    circular
                    link
                    onClick={handleCheckCoupon}
                />}
                onKeyPress = {(e) => {
                    if(e.key === 'Enter'){
                        handleCheckCoupon();
                    }
                }}
                onChange={(e, {value}) => {
                    setCoupon(value);
                }}
            />
        </p>

        <div>
            <Form.Field>
                <p>
                    <strong>Total:</strong>{' '} R$ {(amount).toFixed(2)}<br/>
                    {discount.success ? <><strong>Desconto:</strong>{' '} R$ {discountValue.toFixed(2)}<br/></> : ''}
                    {freightValue ? <><strong>Frete:</strong>{' '} R$ {freightValue.toFixed(2)}<br/></> : ''}
                    <strong>Valor
                        final:</strong>{' '} R$ {total.toFixed(2)}<br/>
                </p>
            </Form.Field>
        </div>

        <ModalFreight
            open={open}
            setOpen={setOpen}
            course={course}
            quantity={quantity}
            setFreight={setFreight}
        />

        <Button
            id={"buy-button"}
            primary
            fluid
            loading={buying}
            disabled={(course.product && !freight.Valor) || buying}
            content={token ? 'COMPRAR AGORA' : 'LOGIN'}
            onClick={token ? buy : login}
        />
    </div>
}

const now = new Date();
const launch = new Date("2021-03-07 00:00:00");
export const CourseDetails = ({course_id}) => {
    const [loading, setLoading] = useState(false);
    const [course, setCourse] = useState([]);
    const [freight, setFreight] = useState({});
    const [quantity, setQuantity] = useState('1');
    const [coupon_id, setCouponId] = useState();

    // const location = useLocation();
    const place_id = parseInt(course.place_id || 0);
    const history = useHistory();
    const token = sessionStorage.getItem('Token')
    let r_image = '/images/user.png';
    if (course.place && course.place.r_image) {
        r_image = 'https://br.inbh.com.br/files/places/r_image/' + course.place.r_image;
    }

    const duration = course.hours ? course.hours.toFixed(2).toString().split('.') : [0];
    const await_launch = (place_id === 2736 && now.getTime() < launch.getTime());

    const buy = async () => {

        if(await_launch){
            return;
        }

        setLoading(true);

        try {
            const res = await postPeopleCourses({
                course_id,
                quantity,
                freight,
                coupon_id
            });

            if (res.data.link) {
                alert('Você será enviado para página de pagamento do PagSeguro');
                window.top.location.href = res.data.link;
                return;
            }

            window.top.location.href = '/people/courses';

        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false)
        }
    }

    const cover = course.cover ? (course.path + course.cover) : 'https://img-a.udemycdn.com/course/240x135/1586752_2d9e_2.jpg';

    useEffect(() => {
        async function getData() {
            try {
                // get posts
                const result = await getCourses(course_id);

                // set posts
                setCourse(result.data);
            } catch (e) {
                // show errors
                console.log('error', e);
            } finally {
            }
        }

        getData();

    }, [course_id]);

    useEffect(() => {
        async function getData() {

            if(!freight.Codigo){
                return;
            }

            setFreight({...freight, "Valor": 0});

            try {
                let postalType = freight.Codigo;
                let postalCode = freight.address.postal_code;
                let res = await getMainFreight({postalType, postalCode, course, quantity});

                if(res.success){
                    let valor = res.data.Valor.replace(',', '.');

                    setFreight({...freight, "Valor": valor});
                }
            } catch (e) {
                // show errors
                console.log('error', e);
            } finally {
            }
        }

        getData();

    }, [quantity]);

    const login = () => {

        localStorage.setItem('goback', window.location.href);

        history.push('/users/login/1')
    }

    const CourseHeader = ({course}) => {
        return <div
            className={'course-main'}
            style={{
                textAlign: "center",
                background: `url("${cover}")`,
            }}
        >
            <div className={'course-main-content'}>
                <h1>{course.name}</h1>
                <p>{course.description}</p>
                {
                    !course.product && <p>Saiba mais.</p>
                }
                <p>
                    {
                        course.product ? '' : (token
                                ? <Button
                                    disabled={loading}
                                    loading={loading}
                                    onClick={() => window.document.getElementById('buy-button').focus()}
                                >{await_launch ? "Compras a partir de 07/03" : <>Comece agora por apenas <br/> R$ {course.price && course.price.toFixed(2)}</>}
                                </Button>
                                : <Button
                                    color={"red"}
                                    content={"Fazer login antes de comprar"}
                                    onClick={login}
                                />
                        )
                    }

                </p>
                {/*<p>Este curso está disponível para assinantes! Conheça os Planos.</p>*/}
                {/*<p><Icon name={"address card outline"} size={"big"}/> Este curso possui certificado digital de*/}
                {/*    conclusão gratuito.</p>*/}
            </div>
        </div>
    }

    const ProductHeader = ({course}) => {
        return <div
            className={'course-main'}
            style={{
                textAlign: "center",
                background: `url("${cover}")`,
            }}
        >
            <div className={'course-main-content'}>
                <h1>{course.name}</h1>
                <p>{course.description}</p>
            </div>
        </div>
    }

    return (
        <React.Fragment>
            <Segment
                inverted
                attached
                size={'small'}
                style={{padding: 0, border: 0}}
            >
                <Menu
                    stackable
                    inverted
                    secondary
                    style={{
                        margin: 0
                    }}
                >
                    <Container>
                        <Menu.Item header style={{display: 'inline'}}>
                            <div style={{
                                fontWeight: 'bold',
                                lineHeight: '26px'
                            }}>{course.course_category && course.course_category.name}</div>
                            {
                                course.product ? '' :
                                    <div style={{color: '#454545'}}>{course.people_counter || 0} Alunos</div>
                            }
                        </Menu.Item>
                        <Menu.Menu position={"right"}>
                            <Menu.Item>
                                {
                                    course.product ? 'COMPRE:' : 'MATRICULE-SE:'
                                }
                            </Menu.Item>
                            <Menu.Item>
                                {
                                    token
                                        ? <Button
                                            color={"red"}
                                            content={await_launch ? "COMPRAS A PARTIR DE 07/03" : course.product ? "COMPRAR" : "COMPRAR CURSO"}
                                            disabled={loading}
                                            loading={loading}
                                            onClick={() => window.document.getElementById('buy-button').focus()}
                                        />
                                        : <Button
                                            color={"red"}
                                            content={"LOGIN"}
                                            onClick={login}
                                        />
                                }
                            </Menu.Item>
                        </Menu.Menu>
                    </Container>
                </Menu>
            </Segment>
            <Container>
                {
                    course.product ? <ProductHeader course={course} /> : <CourseHeader course={course} />
                }
                <Grid stackable>
                    {
                        !course.product && <Grid.Row columns={4} className={'course-stats'} textAlign={"center"}>
                            <Grid.Column>
                                <div>CARGA HORÁRIA</div>
                                {duration[0] && `${duration[0]}h`}
                                {duration[1] && ` ${duration[1]}m`}
                            </Grid.Column>
                            <Grid.Column>
                                <div>ACESSO PREMIUM</div>
                                {course.expires ? `${course.expires} DIAS` : 'VITALÍCIO'}
                            </Grid.Column>
                            <Grid.Column>
                                <div>PREÇO</div>
                                R$ {course.price && course.price.toFixed(2)}
                            </Grid.Column>
                            <Grid.Column>
                                <div>CRIADO EM</div>
                                {moment(course.created_at).format('DD/MM/YYYY')}
                            </Grid.Column>
                        </Grid.Row>
                    }
                    <Grid.Row>
                        <span className={'course-content-header'}>
                            {
                                course.product ? <span>Descrição do <b>produto:</b></span> :
                                    <span>Conteúdo <b>programático:</b></span>
                            }
                        </span>
                    </Grid.Row>
                    <Grid.Row style={{marginTop: 0, paddingTop: 0}}>
                        <Grid.Column width={10}>
                            {
                                course.product && <div className={'productOver'}>
                                    <img src={cover} />
                                </div>
                            }
                            <div dangerouslySetInnerHTML={{__html: course.content}}/>
                        </Grid.Column>
                        <Grid.Column width={6}>
                            {
                                course.id && <PriceDetails
                                course={course}
                                buying={loading}
                                buy={buy}
                                quantity={quantity}
                                setQuantity={setQuantity}
                                freight={freight}
                                setFreight={setFreight}
                                token={token}
                                login={login}
                                setCouponId={setCouponId}
                            />
                            }
                            {
                                (course && !course.product) &&
                                    <div className={'responsible'}>
                                        <div className={'responsibleTitle'}>
                                            Conheça<br/>
                                            <b>o responsável:</b>
                                        </div>
                                        <div className={'responsibleContent'}>
                                            <Image
                                                src={r_image}
                                                width={100}
                                                height={100}
                                                circular
                                            />

                                            <div className={'responsibleName'}>
                                                {course.place && course.place.r_name}
                                            </div>
                                            <div className={'responsibleBio'}>
                                                <div
                                                    dangerouslySetInnerHTML={{__html: course.place && course.place.r_bio}}/>
                                            </div>
                                        </div>
                                    </div>
                            }

                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        </React.Fragment>
    );
};